import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ShowKindergartenNursery from "src/components/panel/kindergarten_nursery/show_kindergarten_nursery/ShowKindergartenNursery";

const ShowKindergartenNurseryView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("show_kindergarten_nursery_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("show_kindergarten_nursery_title")}
        />
        <ShowKindergartenNursery />
      </Sidebar>
    </>
  );
};

export default ShowKindergartenNurseryView;